/**
 * One provenance chip (spec #47 §3) — #42's four states plus the fifth
 * this spec adds.
 *
 * The fifth is the point of the component. `this tenant · source
 * unrecorded` is not a shrug: it is the honest answer for a value that
 * differs from the platform row with nothing on record saying who changed
 * it. In a product whose whole promise is that a human approved each
 * change, an invented attribution is worse than an admitted gap.
 */

import { Badge, Tooltip } from '@shopify/polaris';

import { PROVENANCE_LABELS, type Provenance } from './provenance';

const TONES: Record<Provenance['tag'], 'info' | 'success' | 'attention' | undefined> =
  {
    default: undefined,
    you: 'info',
    operator: 'attention',
    'agent-proposed-you-approved': 'success',
    'source-unrecorded': 'attention',
  };

export function ProvenanceTag({ provenance }: { provenance: Provenance }) {
  const label = PROVENANCE_LABELS[provenance.tag];
  const detail = provenance.attributedTo
    ? `${provenance.reason} (${provenance.attributedTo})`
    : provenance.reason;

  return (
    <Tooltip content={detail}>
      <Badge tone={TONES[provenance.tag]}>{label}</Badge>
    </Tooltip>
  );
}
